import { fetchApiPost } from "@/lib/api/utils";
export async function subscribeUser() {
  const vapidPublicKey = process.env["REACT_APP_VAPID_PUBLIC_KEY"];
  if (!vapidPublicKey) throw new Error('VAPID_PUBLIC_KEY is not defined');

  const applicationServerKey = urlBase64ToUint8Array(vapidPublicKey); // Function to convert base64 to Uint8Array
  try {
    const swRegistration = await navigator.serviceWorker.ready;
    const subscription = await swRegistration.pushManager.subscribe({
      userVisibleOnly: true, // Required, means every push will result in a user-visible notification
      applicationServerKey: applicationServerKey
    });
    const result = await fetchApiPost('user/notifications/subscription', subscription);
    if (!result.success) {
      throw result;
    }
  } catch (error) {
    console.error('Failed to subscribe the user: ', error);
  }
}

function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}
